export const SCREEN_NAME = 'creativesDashboard';

export const FILTER_PERIOD = 'period';
export const FILTER_PAY_TO = 'payTo';
export const FILTER_TRAFFIC_TYPE = 'trafficTypeId';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_NETWORKS = 'networks';
export const FILTER_CLUSTERS = 'clusters';
export const FILTER_BUSINESS_PARTNERS = 'businessPartners';
export const FILTER_AFFILIATES = 'affiliates';
export const FILTER_CAMPAIGNS = 'campaigns';

export const FILTER_MANAGERS = 'managers';
export const FILTER_OWNERS = 'ownerIds';
export const FILTER_PLATFORMS = 'platformIds';

export const FILTER_GENRES = 'genreIds';
export const FILTER_COUNTRIES = 'countries';
export const FILTER_REAL_COUNTRIES = 'realCountryIds';

export const FILTER_CHANNELS = 'channels';
export const FILTER_CHANNEL_TYPE = 'channelTypes';
export const FILTER_LABELS = 'labelIds';

export const FILTER_CLIENTS = 'clientIds';
export const FILTER_DEVICE_TYPE = 'deviceTypes';

export const FILTER_REAL_CP_FLOWS = 'realConversionPageFlowIds';

export const FILTER_REGISTRATION_TYPE = 'botRegistrationType';
export const FILTER_CAMPAIGNS_TYPES = 'targetingActivityTypeIds';

export const FILTER_FRAUD_TYPE = 'fraudType';
export const FILTER_RE_COUNTER_TYPES = 'reCounterFilterTypes';

export const FILTER_TRAFFIC_TYPE_ADVERTISING = 1;
export const REGISTRATION = 0;
export const EXCLUDE_FRAUD = 1;

export const DIMENSION_CREATIVE = 'CreativeFile';
export const DIMENSION_CONCEPT = 'Concept';

// SpentUsd, TotalRoasD7, OverallTotalCpdD7
export const METRIC_SPENT_USD = 'SpentUsd';
export const METRIC_TOTAL_ROAS_D7 = 'TotalRoasD7';
export const METRIC_TOTAL_CPD_D7 = 'total_cpd_d7';
